/**
 * Exclusive accordion with synced image panel for the Limitless Life section.
 * Uses class toggles + CSS grid slide (no native details) for smooth open/close.
 */
class LimitlessLifeAccordion extends HTMLElement {
  /** @type {AbortController | null} */
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    /** @type {HTMLElement[]} */
    const items = [...this.querySelectorAll('.limitless-life-section__item')];

    /** @type {HTMLElement[]} */
    const mediaItems = [...this.querySelectorAll('.limitless-life-section__media-item')];

    items.forEach((item, index) => {
      const trigger = item.querySelector('.limitless-life-section__trigger');

      if (!(trigger instanceof HTMLButtonElement)) return;

      trigger.addEventListener(
        'click',
        () => {
          if (item.classList.contains('is-active')) return;
          this.#setActive(index, items, mediaItems);
        },
        { signal }
      );
    });

    const initialIndex = items.findIndex((item) => item.classList.contains('is-active'));
    this.#setActive(initialIndex >= 0 ? initialIndex : 0, items, mediaItems);
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = null;
  }

  /**
   * @param {number} index
   * @param {HTMLElement[]} items
   * @param {HTMLElement[]} mediaItems
   */
  #setActive(index, items, mediaItems) {
    items.forEach((item, itemIndex) => {
      const isActive = itemIndex === index;
      item.classList.toggle('is-active', isActive);

      const trigger = item.querySelector('.limitless-life-section__trigger');
      const panel = item.querySelector('.limitless-life-section__panel');

      if (trigger instanceof HTMLButtonElement) {
        trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      }

      if (panel instanceof HTMLElement) {
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      }
    });

    mediaItems.forEach((item, itemIndex) => {
      const isActive = itemIndex === index;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }
}

if (!customElements.get('limitless-life-accordion')) {
  customElements.define('limitless-life-accordion', LimitlessLifeAccordion);
}
